module.exports = __webpack_public_path__ + "img/wxPayPic.897f175c.jpeg";